<template>
  <div>
    <div class="page-header">
      <h3>Completed Tasks</h3>
    </div>

    <CompletedTasksFilter />


    <div>
      <span v-for="date in dateRange">
        <h5 class="text-muted mt-4" v-if="date.dateHeader">{{ date.date | moment("MMMM YYYY") }}</h5>
        <CompletedTaskDateView :date="date" :journal="false"/>
      </span>
    </div>
  </div>
</template>

<script>
import CompletedTaskDateView from "components/CompletedTaskDateView";
import CompletedTasksFilter from "components/CompletedTasksFilter";

export default {
  components: {
    CompletedTaskDateView,
    CompletedTasksFilter
  },
  computed: {
    dateRange: function(){
      var start = new Date();
      var end = new Date();
      var end = end.setDate(end.getDate()-90);
      var arr = new Array();
      var prevMonth = null;

      var dt = new Date(start);
      while (dt >= end) {
        arr.push({ dateHeader: (new Date(dt).getMonth() != prevMonth), date: new Date(dt) });
        prevMonth = new Date(dt).getMonth()
        dt.setDate(dt.getDate() - 1);
      }
      return arr;
    }
  }
};
</script>
